import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\GetDomainConfigurationController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/GetDomainConfigurationController.php
* @route '/api/smtp/domain'
*/
const GetDomainConfigurationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDomainConfigurationController.url(options),
    method: 'get',
})

GetDomainConfigurationController.definition = {
    methods: ["get","head"],
    url: '/api/smtp/domain',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\GetDomainConfigurationController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/GetDomainConfigurationController.php
* @route '/api/smtp/domain'
*/
GetDomainConfigurationController.url = (options?: RouteQueryOptions) => {
    return GetDomainConfigurationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\GetDomainConfigurationController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/GetDomainConfigurationController.php
* @route '/api/smtp/domain'
*/
GetDomainConfigurationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDomainConfigurationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\Mailgun\GetDomainConfigurationController::__invoke
* @see app/Http/Controllers/ModelNotification/Mailgun/GetDomainConfigurationController.php
* @route '/api/smtp/domain'
*/
GetDomainConfigurationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDomainConfigurationController.url(options),
    method: 'head',
})

export default GetDomainConfigurationController